import { Empresa } from "../Hooks/UsuarioHook";

export const Filtro = (filtro: string, empresa: Empresa) => {
    var expression = new RegExp(filtro, "i");

    if (!expression.test(empresa.DESCRICAO) && !expression.test(empresa.FANTASIA) && !expression.test(empresa.CPF) && !expression.test(empresa.CNPJ)) {
        return false;
    }
    return true;

}